import { gql } from '@apollo/client';

import { SchoolRequisitesFragment } from '../fragments';

export const UpdateSchoolMutation = gql`
    mutation UpdateSchool($id: ID!, $item: SchoolArgs!) {
        updateSchool(id: $id, item: $item) {
            requisites {
                ...SchoolRequisites
            }
        }
    }
    ${SchoolRequisitesFragment}
`;
